import { select } from '@panel/commons/core/themev2';
import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  min-height: 93vh;
  background: ${select('neutralGray')};
  display: flex;
  justify-content: center;
  padding-top: ${({ device }) => (device !== 'tablet' ? '24px' : '84px')};
`;

export const Container = styled.div`
  width: ${({ device }) => {
    if (device === 'mobile') return '100%';
    if (device === 'tablet') return '546px';
    return '620px';
  }};
  height: ${({ device }) => (device !== 'mobile' ? '269px' : 'auto')};
  text-align: center;
  background: ${select('white')};
  padding-top: ${({ device }) => (device !== 'mobile' ? '24px' : '10vh')};
  padding-bottom: 32px;
  padding-left: ${({ device }) => (device !== 'mobile' ? '24px' : '16px')};
  padding-right: ${({ device }) => (device !== 'mobile' ? '24px' : '16px')};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
`;

export const Title = styled.h2`
  color: ${select('black')};
  text-align: center;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
`;

export const SubTitle = styled.p`
  color: ${select('black')};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  margin-bottom: 32px;
`;

export const CardContainer = styled.div`
  display: flex;
  justify-content: ${({ device }) => (device !== 'mobile' ? 'space-between' : 'center')};
  flex-wrap: wrap;
`;

export const OptionCard = styled.button`
  display: flex;
  width: ${({ device }) => {
    if (device === 'mobile') return '328px';
    if (device === 'tablet') return '241px';
    return '278px';
  }};
  height: 132px;
  padding: 8px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: 8px;
  border: 1px solid ${select('midDarkGrayAux')};

  &:nth-child(2) {
    margin-left: ${({ device }) => (device !== 'mobile' ? '16px' : '0')};
  }

  &:hover {
    border-radius: 8px;
    border: 1px solid ${select('midDarkGrayAux')};
    background: ${select('neutralGray')};
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.05);
  }

  &:focus,
  &:active {
    outline: none;
    border-radius: 8px;
    border: 1px solid ${select('midDarkGrayAux')};
    background: ${select('neutralGray')};
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.05);
  }
  ${({ device }) =>
    device === 'mobile' &&
    css`
      margin-bottom: 16px;
    `}
`;

export const OptionTitle = styled.h3`
  color: ${select('black')};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  white-space: break-spaces;
  width: 246px;
  padding-left: 16px;
  padding-right: 16px;
`;
